import { useMutation, useQueryClient } from 'react-query';
import { trpc } from '../../../../lib/trpc';
import { getProjectKeys } from './projectQueries';
import { SaveProject } from '@app/trpc-api/models/Binders';

const useUpdateProject = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async (dataToSave: SaveProject) => {
            return trpc.BindersApi.saveProject.query({ project: dataToSave });
        },
        {
            onSettled: async data => {
                queryClient.invalidateQueries(getProjectKeys.lists());
                if (data?.id) queryClient.invalidateQueries(getProjectKeys.detail(+data.id));
            }
        }
    );
};

export default useUpdateProject;
